/**
 * Objective anchors, shared by the steps that list every objective and by the
 * controls that jump between them (the side nav, the "nothing retained" chip).
 */

export const goalAnchor = (goalId: string) => `ap-goal-${goalId}`;

export function jumpToGoal(goalId: string) {
  document
    .getElementById(goalAnchor(goalId))
    ?.scrollIntoView({ behavior: "smooth", block: "start" });
}
